// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"5dd48b3b","170":"1caea6b0","213":"2c778c6e","388":"77741e8a","453":"dc0e173f","562":"7fd97647","671":"a155dcb1","696":"41094a9b","920":"d5406c4e"}[chunkId] + ".chunk.js";
};